// extracted by mini-css-extract-plugin
module.exports = {"goalBlock":"GoalList_goalBlock__gs6m2","goalBlockSelected":"GoalList_goalBlockSelected__lWEtx","goalBlockSpacing":"GoalList_goalBlockSpacing__lLb8z"};